import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";
import { Link } from "react-admin";
import styled from "styled-components";
import * as R from "ramda";
import moment from "moment";

const styles = theme => ({
  h3: {
    textAlign: "center",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  },
  typography: {
    margin: theme.spacing.unit * 2
  }
});

const Column = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  // width: '33%',
  backgroundColor: props.color,
  border: "1px solid #ffffff",
  textAlign: "center"
}));

class VehiclesPopover extends React.Component {
  state = {
    anchorEl: null
  };

  buildItemLIme = item => {
    if (item.descripcion == 'gps_device') {
      let modelName, tipoV, ruta
      if(item.model.model_name != undefined )
      {  
        modelName = item.model.model_name +' : '+ item.licence_plate
        tipoV = 'Vehicles'
        ruta = "#"
      }
      else
      { 
        modelName = item.model
        tipoV = 'GPS'
        ruta = `/gps_schedule?date_start=${moment(item.arrival).format("YYYYMMDD")}&date_end=${moment(item.displacedDate).format("YYYYMMDD")}&location=0&op_date_begin=null&op_date_end=null`
      }
      return (
        <React.Fragment key={`spfr_${item.id}`}>
          <Link style={{ color: "black", }} to= {ruta} >
            <strong>{modelName} </strong> <br />
            {tipoV} in <span style={{ backgroundColor: item.color2, }}>{item.location2}</span> on ({moment(item.displacedDate).subtract(1, "days").format("DD-MM-YYYY")}).
            Needed in <span style={{ backgroundColor: item.color1, }}>{item.location1}</span> on ({moment(item.displacedDate).format("DD-MM-YYYY")})
          </Link>
          <br />
        </React.Fragment>
      );
    }
    else {
      return (
        <React.Fragment key={`spfr_${item.id}`}>
          <Link style={{ color: "black", }} to={`/moto_schedule/?date_start=${moment(item.arrival).format("YYYYMMDD")}&date_end=${moment(item.displacedDate).format("YYYYMMDD")}&location=0&model=${item.model.id}&op_date_begin=null&op_date_end=null`}>
            <strong>{item.model.model_name} : {item.licence_plate} </strong> <br />
            Bike in <span style={{ backgroundColor: item.color2, }}>{item.location2}</span> on ({moment(item.displacedDate).subtract(1, "days").format("DD-MM-YYYY")}).
            Needed in <span style={{ backgroundColor: item.color1, }}>{item.location1}</span> on ({moment(item.displacedDate).format("DD-MM-YYYY")})
          </Link>
          <br />
        </React.Fragment>
      );
    }

  };

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  render() {
    const { classes, items, itemText, key } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    if (R.length(items) > 0) {
      return (
        <Column key={`${key}_c`}>
          <this.props.iconImage
            aria-owns={open ? "simple-popper" : undefined}
            aria-haspopup="true"
            variant="contained"
            onClick={this.handleClick}
            style={{ color: "black", width: "20px" }}
          />
          <Popover
            id="simple-popper"
            key={`${key}_p`}
            open={open}
            anchorEl={anchorEl}
            onClose={this.handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
          >
            <h3 className={classes.h3}>{itemText}</h3>
            <Typography className={classes.typography}>
              {R.map(
                this.buildItemLIme,
                R.sortBy(R.prop("licence_plate"), items)
              )}
            </Typography>
          </Popover>
        </Column>
      );
    }
    return null;
  }
}

VehiclesPopover.propTypes = {
  classes: PropTypes.object.isRequired,
  key: PropTypes.string
};

export default withStyles(styles)(VehiclesPopover);



// WEBPACK FOOTER //
// ./src/components/vehiclesPopover.js